import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Category } from '@/models/CategoryDetail';
import SmartImage from './SmartImage';
import { IMAGE_PLACEHOLDER } from '@/lib/Constants';

interface CategoryCardProps {
  category: Category;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category }) => {
  return (
    <Link
      href={category.url || ''}
      prefetch={false}
      className="mx-auto w-full max-w-[214px] flex flex-col hover:cursor-pointer transform transition-transform duration-300 hover:scale-105"
    >
      <div className="relative rounded-2xl border border-hzc_beige_300 shadow-sm hover:shadow-lg transition-shadow duration-300">
        <SmartImage
          width={214}
          height={244}
          src={category.imageUrl || IMAGE_PLACEHOLDER}
          alt={category.title}
          sizes="214px" // ✅ Sabit boyut için manuel sizes
          className="rounded-2xl aspect-[214/244]"
        />
      </div>
      <div className="mx-auto py-2 text-center">
        <div className="font-semibold text-sm text-hzc_purple_400">{category.title}</div>
      </div>
    </Link>
  );
};

export default CategoryCard;
